module.exports = __webpack_public_path__ + "static/img/tooltip-costs.843b9f1.png";